import { useState } from "react";
import OtpVerifyScreen from "../login/OtpVerifyScreen";
import ForgotPassword from "./ForgotPassword";
import NewPassword from "./NewPassword";

function ForgotPasswordIndex() {
  const [step, setStep] = useState(0);
  const [email, setEmail] = useState("");

  return (
    <>
      {step === 0 ? (
        <>
          <ForgotPassword
            onClick={(data) => {
              setEmail(data.email);
              setStep(1);
            }}
          />
        </>
      ) : step === 1 ? (
        <>
          <OtpVerifyScreen
            email={email}
            isFromForgotPass={true}
            onSuccess={() => {
              setStep(2);
            }}
            forgotpassword
          />
        </>
      ) : (
        step === 2 && (
          <>
            <NewPassword email={email} />
          </>
        )
      )}
    </>
  );
}

export default ForgotPasswordIndex;
